export default __webpack_public_path__ + "static/media/thum1.a9de9892.jpg";